/**
 * Specifies class names
 */
/** @hidden */
export var rowCell = 'e-rowcell';
/** @hidden */
export var gridHeader = 'e-gridheader';
/** @hidden */
export var gridContent = 'e-gridcontent';
/** @hidden */
export var gridFooter = 'e-gridfooter';
/** @hidden */
export var headerContent = 'e-headercontent';
/** @hidden */
export var movableContent = 'e-movablecontent';
/** @hidden */
export var movableHeader = 'e-movableheader';
/** @hidden */
export var frozenContent = 'e-frozencontent';
/** @hidden */
export var frozenHeader = 'e-frozenheader';
/** @hidden */
export var content = 'e-content';
/** @hidden */
export var table = 'e-table';
/** @hidden */
export var row = 'e-row';
/** @hidden */
export var gridChkBox = 'e-gridchkbox';
/** @hidden */
export var editedRow = 'e-editedrow';
/** @hidden */
export var addedRow = 'e-addedrow';
/** @hidden */
export var groupCaptionRow = 'e-groupcaptionrow';
/**
 * Specifies repeated strings
 */
/** @hidden */
export var changedRecords = 'changedRecords';
/** @hidden */
export var addedRecords = 'addedRecords';
/** @hidden */
export var deletedRecords = 'deletedRecords';
/** @hidden */
export var leftRight = 'Left-Right';
/** @hidden */
export var frozenRight = 'frozen-right';
/** @hidden */
export var frozenLeft = 'frozen-left';
/** @hidden */
export var dataColIndex = 'data-colindex';
/** @hidden */
export var ariaColIndex = 'aria-colindex';
/** @hidden */
export var dataRowIndex = 'data-rowindex';
/** @hidden */
export var ariaRowIndex = 'aria-rowindex';
/** @hidden */
export var tbody = 'tbody';
/** @hidden */
export var colGroup = 'colgroup';
/** @hidden */
export var open = 'open';
/** @hidden */
export var change = 'change';
/** @hidden */
export var focus = 'focus';
/** @hidden */
export var create = 'created';
/** @hidden */
export var beforeOpen = 'beforeOpen';
/** @hidden */
export var downArrow = 'downArrow';
/** @hidden */
export var upArrow = 'upArrow';
/** @hidden */
export var pageUp = 'PageUp';
/** @hidden */
export var pageDown = 'PageDown';
/** @hidden */
export var enter = 'enter';
/** @hidden */
export var shiftEnter = 'shiftEnter';
/** @hidden */
export var tab = 'tab';
/** @hidden */
export var shiftTab = 'shiftTab';
/** @hidden */
export var initialFrozenColumnIndex = 'initialFrozenColumnIndex';
